var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdnoklassniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.053 12.21c-1.248-.13-2.373-.433-3.336-1.178-.12-.093-.243-.182-.352-.286-.422-.4-.464-.86-.13-1.33.285-.405.764-.514 1.262-.28.096.044.188.1.276.16 1.795 1.22 4.26 1.253 6.063.055a1.65 1.65 0 0 1 .59-.3c.43-.11.832.046 1.063.418.262.425.26.84-.066 1.17a4.904 4.904 0 0 1-1.763 1.126c-.63.24-1.32.363-2 .444.102.11.15.165.215.23.927.92 1.858 1.836 2.78 2.76.316.315.38.705.21 1.07-.19.4-.615.664-1.03.636-.264-.018-.47-.148-.653-.33-.7-.696-1.412-1.38-2.097-2.088-.2-.206-.295-.167-.47.012-.705.716-1.42 1.42-2.14 2.123-.322.316-.707.372-1.08.192-.4-.19-.653-.592-.633-.996.013-.273.15-.482.34-.67.916-.905 1.83-1.812 2.746-2.72.06-.06.117-.124.205-.217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.813 9.055C6.587 9.047 4.76 7.223 4.773 5.02 4.788 2.79 6.614.993 8.864 1a4.052 4.052 0 0 1 4.05 4.08c-.013 2.2-1.85 3.982-4.1 3.975zm2.023-4.03a1.973 1.973 0 0 0-1.99-1.968 1.976 1.976 0 0 0-1.995 1.99C6.86 6.137 7.75 7.003 8.857 7a1.97 1.97 0 0 0 1.98-1.976z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassniki);
export default __webpack_public_path__ + "static/media/odnoklassniki.fddf6c74bf78a8ffcaa5f5802232fc21.svg";
export { ForwardRef as ReactComponent };